/* eslint-disable indent,react/jsx-indent,react/jsx-indent-props,max-len */
import React, { useEffect, useState } from 'react';
import { connectInfiniteHits } from 'react-instantsearch-dom';
import { InfiniteHitsProvided } from 'react-instantsearch-core';
import RowViewPuppyCard from '../../body/card/row-view-puppy-card';

interface Props extends InfiniteHitsProvided {
  hybrid?: boolean,
  breedSlug?: string,
  listingsType: string,
  setSearchState: (args: any) => void,
}

const InfiniteHits: React.FC<Props> = ({
                                         hits,
                                         hasMore,
                                         setSearchState,
                                       }) => {
  const [initialLoad, setInitialLoad] = useState(false);
  const addToSchema = (hit: any) => {
    const listingScheme = {
      '@type': 'Product',
      id: hit.id,
      image: hit.thumbnailUrl,
      name: hit.name,
      category: hit.breed_name,
      potentialAction: {
        '@type': 'BuyAction',
        price: (hit.real_price / 100),
        priceCurrency: 'USD',
        location: {
          '@type': 'PostalAddress',
          addressLocality: hit.city,
          addressRegion: hit.state,
          postalCode: hit.zip,
        },
      },
    };
    const offerCatalogSchema = document.getElementById('offer-catalog-schema');
    if (offerCatalogSchema) {
      const schemaElement = JSON.parse(offerCatalogSchema.innerText);
      if (!schemaElement.itemListElement.some((item: any) => item.id === hit.id)) {
        schemaElement.itemListElement.push(listingScheme);
        offerCatalogSchema.innerText = JSON.stringify(schemaElement);
      }
    }
  };

  useEffect(() => {
    if (!initialLoad && hits.length > 0) {
      hits.forEach((hit) => {
        addToSchema(hit);
      });
      setInitialLoad(true);
    }
  }, [hits]);

  return (
    <div id="search-page" className="d-flex flex-column">
      <div className="ais-InfiniteHits">
        <ul className="ais-InfiniteHits-list">
          {hits.map((hit) => (
            <li key={hit.objectID} className="ais-InfiniteHits-item">
              <div className="row-view-react-puppy-card">
                <RowViewPuppyCard puppy={hit} key={hit.objectID} />
              </div>
            </li>
          ))}
        </ul>
        {hasMore && (
          <button
            className="ais-InfiniteHits-loadMore"
            disabled={!hasMore}
            onClick={() => {
              setSearchState(
                (s) => ({
                  ...s,
                  page: (s.page || 1) + 1,
                }),
              );
            }}
          >
            Load More
          </button>
        )}
      </div>
    </div>
  );
};
const RowViewCustomRenderListingInfiniteHits = connectInfiniteHits(InfiniteHits);
export default RowViewCustomRenderListingInfiniteHits;
